module.exports = [
  'ru',
  'ru-ua',
  'ru-kz',
  'ru-by',
  'uk-ua',
  'en-gb',
  'en-ie',
  'en-ae',
  'en-us',
  'de',
  'pl',
  'tr',
  'es',
];
